export default {
  name: 'PolicyPage',
  data() {
    return {
      policyText: '',
      loading: false,
      error: '',
    };
  },
  mounted() {
    this.loadPolicy();
  },
  methods: {
    async loadPolicy() {
      this.loading = true;
      this.error = '';

      this.$store.getters.axl.post('profiles/api/register/page', { page: 'policy' })
        .then(async (response) => {
          this.policyText = response.data.page;
          this.loading = false;
          console.error(response.data);
        })
        .catch(async (error) => {
          console.error('Ошибка загрузки:', error);
          this.error = 'Не удалось загрузить документ';
          this.policyText = this.getFallbackText();
          this.loading = false;
        });
    },

    getFallbackText() {
      return `
        <p>Не удалось загрузить документ.</p>
        <p>Пожалуйста, ознакомьтесь с документом по
          <a href="https://wheel.promo-online.pro/policy" target="_blank">ссылке</a>
        </p>
      `;
    },
  },
};
